import { Dispatch } from 'redux';
import { fetchGet, httpError, json } from 'common';
const apiUri: string = process.env.REACT_APP_API_URI as string;

export const fetchRecentReportsService = (
  daysCount: number,
  token: string,
  dispatch: Dispatch,
) =>
  fetchGet(
    `${apiUri}/userExport/lastDays/${daysCount}?expires=${Date.now()}`,
    token,
  )
    .then(httpError(dispatch))
    .then(json);
